import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalController, Platform } from "ionic-angular";
import { PlanOfCareDataService } from "../../../providers/poc-data-service/poc-data-service";

@Component({
  selector: "intervention",
  templateUrl: "intervention.html",
})
export class InterventionComponent {
  @Input() data;
  @Input() status;
  @Input() siblingCount;
  @Input() selectedData;
  @Input() disabled: boolean = false;

  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() onUpdateItem: EventEmitter<any> = new EventEmitter();

  constructor(
    private dataService: PlanOfCareDataService,
    public modalCtrl: ModalController,
    public plt: Platform
  ) {}

  select(data) {
    if (!data.type) {
      data.type = "intervention";
      data.siblingCount = this.siblingCount;
    }

    this.onSelect.emit(data);
  }

  updateItem(event) {
    this.onUpdateItem.emit(event);
  }

  presentDiscontinueInterventionModal() {
    let discontinueGoalModal = this.modalCtrl.create(
      "UpdateStatusPage",
      {
        modalType: "discontinueIntervention",
        data: this.data,
      },
      { enableBackdropDismiss: false }
    );
    discontinueGoalModal.onDidDismiss((data) => {
      if (data) {
        this.dataService
          .updateInterventionStatus(this.data.uuid, data)
          .subscribe(
            (data) => {
              this.updateItem({
                data: this.data,
                action: "discontinueIntervention",
              });
            },
            (err) => {
              // console.error(err);
            }
          );
      }
    });
    discontinueGoalModal.present();
  }

  presentHistoryModal() {
    let historyModal = this.modalCtrl.create(
      "DetailsPage",
      {
        status: this.status,
        type: "intervention",
        data: this.data,
      },
      { enableBackdropDismiss: false }
    );
    historyModal.onDidDismiss((data) => {});
    historyModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/common/intervention/intervention.ts